import request from '../utils/request'
import qs from 'qs'
import { commonConfig } from '../utils/config'
const { apiUrl } = commonConfig

export async function exportExcel(obj) {
  return request(`${apiUrl}/ug-agent-back/v1/token/${obj.apiPath}?${qs.stringify(obj.params)}`, { config: { responseType: 'blob' } })
}
